// @flow
import { createSelector } from 'reselect';
import prop from 'ramda/es/prop';
import sortBy from 'ramda/es/sortBy';
import map from 'ramda/es/map';
import addIndex from 'ramda/es/addIndex';
import pipe from 'ramda/es/pipe';


const mapIndexed = addIndex(map);
const prepareArrayProp = pipe(
  mapIndexed(({ position, ...others }, i) => ({
    ...others,
    position,
    id: `${i}-${position}`,
  })),
  sortBy(prop('position')),
);

type Image = {
  is_default: boolean,
  thumb: string,
  standart: string,
  high: string,
  position: number,
}

type OptionValue = {
  id: number,
  name: string,
}

type Variant = {
  id: number,
  position: number,
  sku: number,
  name: string,
  weight: string,
  height: string,
  width: string,
  depth: string,
  price: string,
  wholesale_price: number,
  compare_at_price: string,
  image: {
    thumb: string,
    standart: string,
    high: string,
  },
  option_values: Array<OptionValue>,
}

type OptionValue2 = {
  id: number,
  name: string,
  price_modifier_type: number,
  price_modifier: string,
}

type Option = {
  name: string,
  id: number,
  product_option_type: number,
  is_required: boolean,
  option_values: Array<OptionValue2>,
}

type Property = {
  position: number,
  presentation: string,
  value: string,
}

type StockItem = {
  id: number,
  quantity: string,
  reserved: string,
  name: string,
}

type ApiProduct = {
  // id: number,
  name: string,
  slug: string,
  description: string,
  meta_title: string,
  meta_description: string,
  meta_keywords: null,
  images: Array<Image>,
  master: {
    id: number,
    is_master: boolean,
    is_default: boolean,
    position: number,
    sku: string,
    name: string,
    weight: string,
    height: string,
    width: string,
    depth: string,
    price: string,
    wholesale_price: number,
    compare_at_price: string,
  },
  variants: Array<Variant>,
  options: Array<Option>,
  properties: Array<Property>,
  stock_items: Array<StockItem>,
}

// $FlowFixMe
const selectProduct = createSelector(
  state => state.shop.catalog.product.data,
  ({
    // id,
    slug,
    name,
    images,
    master,
    description,
    properties,
  }: ApiProduct) => ({
    id: prop('id', master),
    slug,
    title: name,
    images: prepareArrayProp(images || []),
    price: prop('price', master),
    description,
    properties: prepareArrayProp(properties || []),
  }),
);

export default selectProduct;
